export default "__VITE_ASSET__BZXfFL1z__"